import { useEffect, useRef } from 'react';

export default function FinalCTASection() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.querySelectorAll('.cta-animate').forEach((child, i) => {
              (child as HTMLElement).style.animationDelay = `${i * 0.12}s`;
              child.classList.add('animate-fade-in-up');
            });
            obs.unobserve(el);
          }
        });
      },
      { threshold: 0.1 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} id="download" className="relative w-full py-24 md:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src="/images/cta-cocktails.jpg"
          alt="Night city"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-background-950/70" />
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="cta-animate opacity-0 text-4xl sm:text-5xl md:text-6xl font-black text-foreground-50 tracking-tight leading-tight mb-6">
            NEXT ROUND&apos;S<br />
            <span className="text-primary-500">ON YOU.</span>
          </h2>
          <p className="cta-animate opacity-0 text-foreground-400 text-lg md:text-xl max-w-lg mx-auto leading-relaxed mb-10">
            Send a drink. Make someone&apos;s night. Download MARKER and start the conversation.
          </p>

          <div className="cta-animate opacity-0 flex flex-wrap items-center justify-center gap-4 mb-8">
            <a
              href="https://apps.apple.com/in/app/mrkr/id6748701173"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-6 py-3.5 bg-foreground-50 text-background-950 rounded-xl hover:bg-foreground-100 transition-colors"
            >
              <i className="ri-apple-fill text-xl" />
              <div className="text-left">
                <p className="text-[10px] leading-none opacity-70">Download on the</p>
                <p className="text-sm font-bold leading-tight">App Store</p>
              </div>
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.marker.app"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-6 py-3.5 bg-primary-500 text-background-950 rounded-xl hover:bg-primary-400 transition-colors"
            >
              <i className="ri-google-play-fill text-xl" />
              <div className="text-left">
                <p className="text-[10px] leading-none opacity-70">Get it on</p>
                <p className="text-sm font-bold leading-tight">Google Play</p>
              </div>
            </a>
          </div>

          <a
            href="https://api.yourmarkerapp.com/public/contactUs.html"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-animate opacity-0 inline-flex items-center gap-2 text-foreground-400 text-sm font-medium hover:text-primary-500 transition-colors"
          >
            Partner with MARKER
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}